// ----------------------------------------------------------------------
// <copyright file="Izenda.MyProfileMenuStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function () {
  var m = require('mobx');
  var constants = require('./data/Izenda.MyProfileConstants');
  var uiState = require('logic/Izenda.UiState');

  function MyProfileMenuStore() {
    this.contextMenu = constants.MENU_DEFINITION;

    var contextMenuActiveLink = uiState.getOpenExportManagerStatus()
      ? constants.MENU_DEFINITION[2].key
      : constants.MENU_DEFINITION[0].key;

    m.extendObservable(this, {
      contextMenuActiveLink: contextMenuActiveLink,
      menuStatus: false
    });
  }

  /**
   * Change active link
   * @param {type} newLink
   */
  MyProfileMenuStore.prototype.changeActiveLink = m.action('changeMenuItem', function (newLink) {
    if (this.contextMenuActiveLink !== newLink) {
      this.contextMenuActiveLink = newLink;
    }
  });

  /**
   * Update menu state
   * @param {type} newState
   */
  MyProfileMenuStore.prototype.updateMenuState = m.action('updateMenuState', function (newState) {
    this.menuStatus = newState;
  });

  module.exports = MyProfileMenuStore;
}());



// WEBPACK FOOTER //
// ./ui/logic/Izenda.MyProfileMenuStore.js